

<template>
  <div class="delivery">
    <div class="main">
      <!-- <div class="top-search">
              <div class="item"><span>交付商名称：</span><div><el-autocomplete v-model="input" :fetch-suggestions="querySearch" @select="handleSelect" placeholder="单行输入"></el-autocomplete></div></div>
              <div class="item"><span style="width: 30px;"></span><el-button type="primary">搜索</el-button><el-button type="primary" plain>重置</el-button></div>
      </div>-->
      <div class="left-button">
        <el-button
          type="primary"
          @click="dialogTitle = '新增',dialogVisible = true, domicileRuleForm.id = ''"
          size="small"
        >新增</el-button>
        <el-button type="danger" @click="currentDel" size="small">删除</el-button>
      </div>
      <div class="bottom-table">
        <el-table
          :data="deliveryTableData"
          @select="domicileSelect"
          @select-all="domicileSelectAll"
          border
          :header-cell-style="{background:'rgb(250, 250, 250)'}"
          style="width: 100%"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column fixed="left" prop="id" label="交付商编码" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="name" label="交付商" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="businessmenDivide" label="个体工商户注册业务分成(%)" width="200" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoiceDivide" label="代开发票业务分成(%)" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="isEnabled" label="是否启用" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div v-if="scope.row.isEnabled == 0">否</div>
              <div v-if="scope.row.isEnabled == 1">是</div>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-button
                        @click="editOperation(scope.row)"
                        type="danger"
                        size="mini"
                        plain
                      >&emsp;编辑&emsp;</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="currentPage"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
    >
      <div style="width: 600px;">
        <el-form
          :model="domicileRuleForm"
          :rules="rules"
          ref="domicileRuleForm"
          label-width="235px"
          class="demo-ruleForm"
        >
          <el-form-item label="交付商：" prop="name">
            <el-input v-model="domicileRuleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="个体工商户注册业务分成（%）：" prop="businessmenDivide">
            <el-input v-model="domicileRuleForm.businessmenDivide"></el-input>
          </el-form-item>
          <el-form-item label="代开发票业务分成（%）：" prop="invoiceDivide">
            <el-input v-model="domicileRuleForm.invoiceDivide"></el-input>
          </el-form-item>
          <el-form-item label="是否启用：" prop="isEnabled">
            <el-switch v-model="domicileRuleForm.isEnabled" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="domicileRuleForm.remark" type="textarea" rows="4" resize="none"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('domicileRuleForm')">确定</el-button>
            <el-button @click="resetForm('domicileRuleForm')">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";

export default {
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "新增",
      currentPage: 4,
      pageSize: 10,
      restaurants: [],
      domicileIds: [],
      deliveryName: "",
      deliveryTableData: [],
      domicileRuleForm: {
        id: "",
        name: "",
        remark: "",
        businessmenDivide: "",
        invoiceDivide: "",
        isEnabled: "1"
      },
      rules: {
        name: [
          { required: true, message: "请输入交付商名称", trigger: "blur" }
        ],
        remark: [
          { required: true, message: "请输入交付商详情", trigger: "blur" }
        ],
        businessmenDivide: [
          { required: true, message: "请输入个体户分成比例", trigger: "blur" }
        ],
        invoiceDivide: [
          { required: true, message: "请输入发票分成比例", trigger: "blur" }
        ]
      }
    };
  },
  components: {
    pagination: pagination
  },
  mounted() {
    // this.restaurants = this.loadAll();
    this.deliveryPagePost();
  },
  methods: {
    domicileSelectAll(arr) {
      console.log(arr);
      this.domicileIds = [];
      for (let i = 0; i < arr.length; i++) {
        this.domicileIds.push(arr[i].id);
      }
    },
    domicileSelect(arr, row) {
      this.domicileIds = [];
      for (let i = 0; i < arr.length; i++) {
        this.domicileIds.push(arr[i].id);
      }
    },
    currentDel() {
      console.log(this.domicileIds);
      if (this.domicileIds.length == 0) {
        return;
      }
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          post(api.deliveryDel, {
            ids: this.domicileIds
          }).then(
            d => {
              if (d.status === 0) {
                console.log(d, "!!!!!!!!!!!!");
                this.deliveryPagePost();
              } else {
                console.log(d.msg);
              }
            },
            err => {
              //error callback
            }
          );
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    submitForm(formName) {
      console.log(this.domicileRuleForm);
      this.$refs[formName].validate(valid => {
        if (valid) {
          post(api.deliverySave, this.domicileRuleForm).then(
            d => {
              if (d.status === 0) {
                console.log(d, "!!!!!!!!!!!!");
                this.$message({
                  showClose: true,
                  message: "操作成功",
                  type: "success"
                });
                this.deliveryPagePost();
                this.$refs[formName].resetFields();
                this.domicileRuleForm.remark = "";
                this.dialogVisible = false;
              } else {
                console.log(d.msg);
              }
            },
            err => {
              //error callback
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.domicileRuleForm.remark = "";
      this.dialogVisible = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.deliveryPagePost();
      console.log(`每页 ${val} 条aaaaa`);
    },
    handleCurrentChange(val) {
      this.deliveryPagePost(val);
      console.log(`当前页: ${val}aaaaaaaaaaaaaaaa`);
    },
    editOperation(row) {
      this.dialogTitle = "编辑";
      post(api.deliveryInfo, {
        id: row.id
      }).then(
        d => {
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.domicileRuleForm.id = d.data.id;
            this.domicileRuleForm.name = d.data.name;
            this.domicileRuleForm.isEnabled = String(d.data.isEnabled);
            this.domicileRuleForm.remark = d.data.remark;
            this.domicileRuleForm.businessmenDivide = d.data.businessmenDivide;
            this.domicileRuleForm.invoiceDivide = d.data.invoiceDivide;
            this.dialogVisible = true;
          } else {
            this.domicileRuleForm.id = row.id;
            this.domicileRuleForm.name = row.name;
            this.domicileRuleForm.isEnabled = String(row.isEnabled);
            this.domicileRuleForm.remark = row.remark;
            this.domicileRuleForm.businessmenDivide = row.businessmenDivide;
            this.domicileRuleForm.invoiceDivide = row.invoiceDivide;
            this.dialogVisible = true;
            console.log(d.msg);
          }
        },
        err => {
          //error callback
        }
      );
    },
    handleClose(done) {
      this.$refs.domicileRuleForm.resetFields();
      this.domicileRuleForm.remark = "";
      done();
    },
    deliveryPagePost(size) {
       const loading = this.$loading({
        lock: true,
        spinner: "loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      post(api.deliveryPage, {
        currentPage: size,
        pageSize: this.pageSize
      }).then(
        d => {
            loading.close();
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.currentPage = d.data.count;
            this.deliveryTableData = d.data.rows;
          } else {
            console.log(d.msg);
          }
        },
        err => {
          //error callback
        }
      );
    }
    // loadAll() {
    //   return [
    //     { "value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号" },
    //   ];
    // },
    // handleSelect(item) {
    //   console.log(item);
    // },
    // createFilter(queryString) {
    //   return (restaurant) => {
    //     return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //   };
    // },
    // querySearch(queryString, cb) {
    //   var restaurants = this.restaurants;
    //   var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
    //   cb(results);
    // },
  }
};
</script>

<style lang="less" scoped>
.delivery {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        span {
          display: inline-block;
          // width: 110px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .left-button {
      text-align: left;
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
    .dialog-header {
      width: 100%;
      height: 49px;
      line-height: 49px;
      background: rgba(20, 147, 250, 0.1);
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: #333333;
      text-align: left;
      div {
        float: left;
        width: 116px;
        height: 49px;
        background: rgba(20, 147, 250, 1);
        color: #ffffff;
        text-align: center;
        margin-right: 28px;
      }
    }
    .dialong-content {
      width: 100%;
      height: 565px;
      background: rgba(216, 216, 216, 0.28);
      margin-top: 23px;
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/system/maintenance/delivery.vue